import { FC } from 'react';

import { FormattedMessage } from 'dibs-react-intl';
import { Bar } from 'dibs-elements/exports/Bar';

import IFramedPromoPartnershipPCForm from './IFramedPromoPartnershipPCForm';
import IFramedPromoPartnershipStartShoppingCta from './IFramedPromoPartnershipStartShoppingCta';

import { ReducerState, DispatchType } from './reducer';

import sharedStyles from './styles/shared.scss';
import styles from './styles/IFramedPromoPartnershipNoPromoToken.scss';

type Props = {
    state: ReducerState;
    dispatch: DispatchType;
};

const IFramedPromoPartnershipNoPromoToken: FC<Props> = ({ state, dispatch }) => {
    const { isLoading } = state;

    return (
        <div className={sharedStyles.wrapper}>
            <div className={sharedStyles.header}>
                <p className={styles.title}>
                    <FormattedMessage
                        id="iFramedpromoPartnership.IFramedPromoPartnershipNoPromoToken.subtitle"
                        defaultMessage="If you require a Private Client Consultation please submit the form below."
                    />
                </p>
                <Bar />
            </div>
            <IFramedPromoPartnershipPCForm state={state} dispatch={dispatch} />
            <IFramedPromoPartnershipStartShoppingCta
                type="transparent"
                fullWidth
                disabled={isLoading}
            />
        </div>
    );
};

export default IFramedPromoPartnershipNoPromoToken;
